import React, {useEffect, useState} from "react";
import {User} from "../../types"
import userService from "../../services/user";
import {Container, InfoText} from "../ui";
import {Button, ErrorIcon} from "@fluentui/react-northstar"
import botService from "../../services/bot-link";
import {app} from "@microsoft/teams-js";

const TEXT_STYLE = {
  justifyContent: "left",
  textAlign: "left" as "left",
}

const LogoutPage: React.FC = () => {
  const [currentUser, setCurrentUser] = useState<User>()
  const [logoutFailed, setLogoutFailed] = useState<boolean>(false)

  useEffect(() => {
    userService.getCurrentUser().then((currentUser) => {
      setCurrentUser(currentUser)

      app.initialize().then(() => app.notifySuccess())
    }).catch((e) => {
      console.log("Error fetching current user:", e)
      app.initialize().then(() => app.notifyFailure({reason: app.FailedReason.Timeout}))
    })
  }, [])

  const handleOnClick = async () => {
    try {
      const res = await botService.botUnlinkUser(currentUser?.uuid!)

      if (res) {
        window.location.reload()

        return
      }
    } catch (e) {
      // no-op
    }

    setLogoutFailed(true)
  }

  if (currentUser) {
    return (
      <Container style={{display: "inline-block"}}>
        <InfoText
          style={{
            fontSize: 30,
            fontWeight: "bold",
            ...TEXT_STYLE
          }}>
          Settings
        </InfoText>
        <InfoText style={TEXT_STYLE}>
          Log out to unlink you Perkbox account from Microsoft Teams.
        </InfoText>
        <Button
          styles={{
            marginTop: "60px",
            width: "300px",
            height: "35px"
          }}
          onClick={handleOnClick}>
          Logout
        </Button>
        <InfoText style={{
          visibility: (logoutFailed) ? "visible" : "hidden",
          color: "#C4314B",
          fontSize: "90%",
          ...TEXT_STYLE
        }}>
          <ErrorIcon outline styles={{marginRight: "5px", marginTop: "1px"}}/> Unable to log out. Please try again.
        </InfoText>
      </Container>
    )
  }

  return (
    <Container>
      <InfoText style={{
        fontSize: 30,
        fontWeight: "bold",
        ...TEXT_STYLE
      }}>
        You're not logged in
      </InfoText>
      <InfoText style={TEXT_STYLE}>
        In order to view Settings, you need to be logged in to Perkbox first. <br/> To do so, open any conversation and
        click on the Perkbox icon just below where you type a message.
      </InfoText>
    </Container>
  )
}

export default LogoutPage
